import { useState, useEffect } from 'react';
var getWidth = function () { return window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth; };
export var useWindowWidth = function () {
    var _a = useState(getWidth()), width = _a[0], setWidth = _a[1];
    useEffect(function () {
        var timeoutId = null;
        var resizeListener = function () {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () { return setWidth(getWidth()); }, 100);
        };
        window.addEventListener('resize', resizeListener);
        return function () {
            window.removeEventListener('resize', resizeListener);
        };
    }, []);
    return width;
};
